import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {useLazyQuery} from '@apollo/client'
import {KEY_PERFORMANCE_METRICS_DATA} from '../../../utils/GraphQLAPI'
import TeamAdminSaleschannelFilter from './TeamAdminSaleschannelFilter'
import { Spinner } from 'react-bootstrap'
import momentTimezone from 'moment-timezone'
import './teamAdmin.scss'

type Props = {
  className: string
}

const KeyPerformanceList: React.FC<Props> = ({className}) => {
  const [KPMData, setKPMData] = useState<any>([])
  const acceptanceRate = 'Acceptance Rate'
  const successRate = 'Conversion Rate'

  useEffect(() => {
    getKeyPerformancemetricsData({
      variables: {localTimeZone: momentTimezone.tz.guess(), saleChannelsIds: null},
    })
  }, [])// eslint-disable-line react-hooks/exhaustive-deps

  // KPM Data query
  const [getKeyPerformancemetricsData, {loading :reload}] = useLazyQuery(
    KEY_PERFORMANCE_METRICS_DATA,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        setKPMData(data.getKpmByTeamAdmin)
      },
    }
  )

  // Filter
  const teamAdminSalesChannelFilter = (data: any) => {
    getKeyPerformancemetricsData(data)
  }



  const renderKPMData = (kpmData: any, i: number) => {
    const { tpvToday, kpiStatus, tpvStatusType, tpvYesterday, tpvLastQuarter, tpvLastWeek, tpvLastMonth } = kpmData

    return (
      <tr style={{ height: '55px', marginTop: '40px' }} className='border-bottom-2' key={i}>
        <td className='min-w-200px pl-4' style={{ paddingLeft: '13px' }}>
          <span className='text-dark semi-bold d-block mb-1 fs-6 tableBodyDataStyle'>
            {kpiStatus === 'Auto_Approved' &&
              `TPVs ${kpiStatus}`}
            {kpiStatus === 'Need_More_Information' &&
              tpvStatusType === 'QC' &&
              `TPVs ${kpiStatus}`}
            {kpiStatus === 'Pending' &&
              tpvStatusType === 'QC' &&
              `TPVs ${kpiStatus} QC Review`}
            {kpiStatus === 'Accepted' &&
              tpvStatusType === 'QC' &&
              `TPVs ${kpiStatus}`}
            {kpiStatus === 'Rejected' &&
              tpvStatusType === 'QC' &&
              `TPVs ${kpiStatus}`}
            {kpiStatus === acceptanceRate &&
              tpvStatusType === 'QC' &&
              `TPVs ${kpiStatus} (TPVs Accepted/Total TPVs)`}
            {kpiStatus === 'Passed' &&
              tpvStatusType === 'TPV' &&
              `TPVs ${kpiStatus}`}
            {kpiStatus === successRate &&
              tpvStatusType === 'TPV' &&
              `TPVs ${kpiStatus} (TPVs Passed/Total TPVs)`}
            {kpiStatus === 'Not Passed' &&
              tpvStatusType === 'TPV' &&
              `TPVs ${kpiStatus} (TPV Incomplete and TPV Failed)`}
          </span>
        </td>
        <td className='min-w-100px tableBodyDataStyle'>
          <span className='text-dark semi-bold d-block mb-1 fs-6'>
            {(() => {
              let displayValue;
              if (kpiStatus === acceptanceRate || kpiStatus === successRate) {
                const num = Number(tpvToday);
                displayValue = `${num !== 0 ? num.toFixed(2) : num}%`;
              } else {
                displayValue = tpvToday;
              }
              return displayValue;
            })()}
          </span>
        </td>
        <td className='min-w-100px tableBodyDataStyle'>
          <span className='text-dark semi-bold d-block mb-1 fs-6'>
            {(() => {
              let displayYesterday;
              if (kpiStatus === acceptanceRate || kpiStatus === successRate) {
                const num = Number(tpvYesterday);
                displayYesterday = `${num !== 0 ? num.toFixed(2) : num}%`;
              } else {
                displayYesterday = tpvYesterday;
              }
              return displayYesterday;
            })()}
          </span>
        </td>
        <td className='min-w-100px tableBodyDataStyle'>
          <span className='text-dark semi-bold d-block mb-1 fs-6'>
            {(() => {
              let displayLastWeek;
              if (kpiStatus === acceptanceRate || kpiStatus === successRate) {
                displayLastWeek = `${Number(tpvLastWeek) !== 0
                  ? Number(tpvLastWeek).toFixed(2)
                  : tpvLastWeek
                  }%`;
              } else {
                displayLastWeek = tpvLastWeek;
              }
              return displayLastWeek;
            })()}
          </span>
        </td>
        <td className='min-w-100px tableBodyDataStyle'>
          <span className='text-dark semi-bold d-block mb-1 fs-6'>
            {(() => {
              let displayLastMonth;
              if (kpiStatus === acceptanceRate || kpiStatus === successRate) {
                const num = Number(tpvLastMonth);
                displayLastMonth = `${num !== 0 ? num.toFixed(2) : num}%`;
              } else {
                displayLastMonth = tpvLastMonth;
              }
              return displayLastMonth;
            })()}
          </span>
        </td>
        <td className='min-w-100px tableBodyDataStyle'>
          <span className='text-dark semi-bold d-block mb-1 fs-6'>
            {(() => {
              let displayLastQuarter;
              if (kpiStatus === acceptanceRate || kpiStatus === successRate) {
                const num = Number(tpvLastQuarter);
                displayLastQuarter = `${num !== 0 ? num.toFixed(2) : num}%`;
              } else {
                displayLastQuarter = tpvLastQuarter;
              }
              return displayLastQuarter;
            })()}
          </span>
        </td>
      </tr>

    )
  }

  return (
    <>
      <div className={`card ${className}`} style={{borderRadius: '12px'}}>
        {/* begin::Header */}
        <div className='card-header border-0 rounded-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Key Performance Metrics</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>
              <strong className='text-dark'>{KPMData?.noOfReports}</strong> Total TPVs
            </span>
          </h3>
          <div className='d-flex'>
            <TeamAdminSaleschannelFilter
              getKeyPerformancemetricsData={teamAdminSalesChannelFilter}
              colors={'dark'}
            />
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <KTCard>
          <KTCardBody>
            {/* begin::Table container */}
            {reload ? (
              <div className="text-center mb-20">
                <Spinner animation="border" className="text-gray-600 text-center" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>) : (
              <div className='table-responsive-xxl'>
                {/* begin::Table */}
                <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                  {/* begin::Table head */}
                  <thead>
                    <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                      <th className='min-w-200px' style={{ paddingLeft: '22px' }}>
                        KPIs
                      </th>
                      <th className='min-w-100px header_title'>Today</th>
                      <th className='min-w-100px header_title'>Yesterday</th>
                      <th className='min-w-100px header_title'>Last Week</th>
                      <th className='min-w-100px header_title'>Last Month</th>
                      <th className='min-w-100px header_title'>Last Quarter</th>
                    </tr>
                  </thead>
                  {/* end::Table head */}

                  {/* begin::Table body */}
                  <tbody>
                    {KPMData &&
                      KPMData?.kpmData?.map(renderKPMData)}
                  </tbody>
                  {/* end::Table body */}
                </table>
                {/* end::Table */}
              </div>)}
            {/* end::Table container */}
          </KTCardBody>
        </KTCard>
        {/* begin::Body */}
      </div>
    </>
  )
}

export { KeyPerformanceList }
